import { Attribute, AttributePropertyValues, IAttribute } from "../System.Runtime/Attribute";
import { NAMESPACE } from "./_Namespace";

export type ClientAwareStringLengthAttributePropertyValues =
    AttributePropertyValues
    & {
        maximumLength: number;
        minimumLength: number;
        requiresValidationContext: boolean;
    };

export type ClientAwareStringLengthAttributeProperties = {
    [name in keyof ClientAwareStringLengthAttributePropertyValues]?: ClientAwareStringLengthAttributePropertyValues[name];
};

export interface IClientAwareStringLengthAttribute extends IAttribute, ClientAwareStringLengthAttributeProperties
{
}

export class ClientAwareStringLengthAttribute extends Attribute implements IClientAwareStringLengthAttribute
{
    public static override classNamespace = NAMESPACE + "ClientAwareStringLengthAttribute";
    public static override className = "ClientAwareStringLengthAttribute";

    public maximumLength?: number;
    public minimumLength?: number;
    public requiresValidationContext?: boolean;

    constructor(propertyValues?: Partial<ClientAwareStringLengthAttributePropertyValues>)
    {
        super(propertyValues);

        this.maximumLength = propertyValues?.maximumLength;
        this.minimumLength = propertyValues?.minimumLength;
        this.requiresValidationContext = propertyValues?.requiresValidationContext;
    }
}